import React from "react";
import { Link } from "react-router-dom";

const COPYRIGHT_YEAR = new Date().getFullYear();

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#E6E2D8] bg-[#F2EFE9] py-8 mt-12"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <p className="text-xs text-[#6B655D]">
          © {COPYRIGHT_YEAR} Colleague — Built for the days at work.
        </p>
        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-[#6B655D]">
          <Link
            to="/pricing"
            data-testid="footer-pricing"
            className="hover:text-[#2D2926] transition-colors"
          >
            Pricing
          </Link>
          <Link
            to="/about"
            data-testid="footer-about"
            className="hover:text-[#2D2926] transition-colors"
          >
            About
          </Link>
          <Link
            to="/privacy"
            data-testid="footer-privacy"
            className="hover:text-[#2D2926] transition-colors"
          >
            Privacy
          </Link>
          <Link
            to="/terms"
            data-testid="footer-terms"
            className="hover:text-[#2D2926] transition-colors"
          >
            Terms
          </Link>
          <Link
            to="/disclaimer"
            data-testid="footer-disclaimer"
            className="hover:text-[#2D2926] transition-colors"
          >
            Disclaimer
          </Link>
          <Link
            to="/refunds"
            data-testid="footer-refunds"
            className="hover:text-[#2D2926] transition-colors"
          >
            Refunds
          </Link>
          <Link
            to="/contact"
            data-testid="footer-contact"
            className="hover:text-[#2D2926] transition-colors"
          >
            Contact
          </Link>
        </nav>
      </div>
    </footer>
  );
}
